import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { auth } from "@/lib/db";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const initRan = useRef(false);

  useEffect(() => {
    if (initRan.current) return;
    initRan.current = true;
    // fast local check first
    const local = auth.getLocalUser();
    if (local) setUser(local);
    // then verify with server
    auth.getUser().then((u) => {
      setUser(u);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const session = await auth.signIn(email, password);
    setUser(session.user);
    return session.user;
  };

  const register = async (name, email, password) => {
    const result = await auth.signUp(email, password, { name });
    if (result.user && !result.needsConfirmation) setUser(result.user);
    return result.user;
  };

  const logout = async () => { await auth.signOut(); setUser(null); };

  const displayName = user?.user_metadata?.name || user?.email?.split("@")[0] || "";
  return (
    <AuthCtx.Provider
      value={{
        user: user ? { ...user, name: displayName } : null,
        loading, login, register, logout,
      }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
